import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { HourRegistrationComponent } from './pages/hour-registration/hour-registration.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { ProjectWeekReportConfigComponent } from './pages/project-week-report-dialog/project-week-report-config.component';
import { UserEditComponent } from './pages/users/user-edit/user-edit.component';
import { VkmPlanningComponent } from './pages/vkm/vkm-planning/vkm-planning.component';

@Injectable()
export class CanDeactivateForm<
    T extends
        | HourRegistrationComponent
        | ProjectWeekReportConfigComponent
        | VkmPlanningComponent
        | ProfileComponent
        | UserEditComponent,
> {
    constructor() {}

    canDeactivate(
        component: T,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (component.openChangesBackActionCheck) {
            return component.openChangesBackActionCheck();
        }
        return true;
    }
}
